import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/AuthContext';
import MatchSchedulingPanel from '../../../components/MatchSchedulingPanel';

const Box = styled.div`
  margin-top: 0.75rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
`;

const Sub = styled.p`
  margin: 0 0 0.75rem;
  font-size: 0.9rem;
  color: #64748b;
`;

export default function HelpMatchSchedulePanel({ teamContext, match }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const teamId = teamContext?.teamId;
  const matchId = match?.id;

  if (!teamId || !matchId) {
    return null;
  }

  return (
    <Box>
      <Sub>
        {match?.opponent
          ? t('phase2.playerHelpWizard.matchVs', { name: match.opponent })
          : t('phase2.playerHelpWizard.matchFallback', { id: String(matchId).slice(0, 8) })}
      </Sub>
      <MatchSchedulingPanel
        active
        matchId={String(matchId)}
        teamId={String(teamId)}
        viewerPlayerId={user?.playerId || user?.id || null}
      />
    </Box>
  );
}
